import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import ParticleBackground from "./Background";
import InfoCard from "./InfoCard";
import img from "./icon/heroImgBackground.png";

const GridDesktop = ({ Img3, features }) => {
  return (
    <Stack
      sx={{
        position: "relative",
        color: "white",
        height: "100vh",
        // width: '100vw',
        overflow: "hidden",
      }}
    >
      <ParticleBackground />

      {/* Main content */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          display: "flex",
          justifyContent: "center",
          pointerEvents: "none", // Allow mouse events to pass through
        }}
      >
        <Stack
          sx={{
            width: { xl: "72%", lg: "89%", md: "89%", sm: "100%", xs: "92%" },
            py: { xl: "64px", lg: "64px", md: "64px", sm: "32px", xs: "16px" },
            pointerEvents: "auto",
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: "22px",
                sm: "26px",
                md: "30px",
                lg: "34px",
              },
              // color: "#054E91",
              color: "#F5F5ED",
              fontFamily: "'Roboto', sans-serif",
              fontWeight: 600,
              letterSpacing: "0.5px",
              textAlign: "left",
              mb: 2,
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Stack
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Stack
                sx={{
                  width: { xl: "6px", lg: "6px", xs: "4px" },
                  height: { xs: "22px", sm: "36px", md: "30px" },
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  border: "1px solid white",
                  backgroundColor: "white",
                  marginRight: "8px",
                  borderTopRightRadius: "8px",
                  borderBottomRightRadius: "8px",
                }}
              >
                <h4 style={{ color: "white" }}>{""}</h4>
              </Stack>
            </Stack>
            <span>
              Engineered for{" "}
              <span style={{ color: "#58ced4" }}>developers</span>{" "}
            </span>
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: {
                xs: "15px",
                sm: "17px",
                md: "20px",
              },
              color: "#F5F5ED",
              lineHeight: { xs: 1.5, sm: 1.8, md: 1.2 },
              fontFamily: "'Roboto', sans-serif",
              mt: -1,
            }}
          >
            Leverage advanced integration capabilities and upgrade automation
            tools experience to create cohesive business experiences.
          </Typography>
          <Stack
            sx={{
              width: {
                xl: "100%",
                lg: "100%",
                md: "100%",
                sm: "100%",
                xs: "95%",
              },
              height: {
                xl: "100%",
                lg: "100%",
                md: "100%",
                sm: "100%",
                xs: "140%",
              },
              paddingLeft: {
                xl: "0px",
                lg: "0px",
                md: "0px",
                sm: "0px",
                xs: "12px",
              },
              paddingRight: {
                xl: "0px",
                lg: "0px",
                md: "0px",
                sm: "0px",
                xs: "0px",
              },
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              mb: 6,
              mt: { xl: 4, lg: 4 },
            }}
          >
            <img
              src={Img3}
              alt="img"
              style={{
                height: "100%",
                width: "100%",
                objectFit: "cover",
                zIndex: 1,
              }}
            />
          </Stack>
          <Stack
            sx={{
              color: "white",
              height: { xl: "auto", lg: "auto", md: "auto", sm: "auto" },
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              mb: { xs: 1, sm: 1, md: 1, lg: 8, xl: 1 },
              pb: { lg: 4 },
            }}
          >
            {features.map((card, index) => (
              <InfoCard
                key={index}
                title={card.title}
                description={card.description}
                icon={card.icon}
              />
            ))}
          </Stack>
        </Stack>
      </Box>
    </Stack>
  );
};

export default GridDesktop;
